/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * constellation object
 * @export
 * @interface PostUniverseIdsConstellation
 */
export interface PostUniverseIdsConstellation {
    /**
     * id integer
     * @type {number}
     * @memberof PostUniverseIdsConstellation
     */
    id?: number;
    /**
     * name string
     * @type {string}
     * @memberof PostUniverseIdsConstellation
     */
    name?: string;
}

/**
 * Check if a given object implements the PostUniverseIdsConstellation interface.
 */
export function instanceOfPostUniverseIdsConstellation(value: object): value is PostUniverseIdsConstellation {
    return true;
}

export function PostUniverseIdsConstellationFromJSON(json: any): PostUniverseIdsConstellation {
    return PostUniverseIdsConstellationFromJSONTyped(json, false);
}

export function PostUniverseIdsConstellationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUniverseIdsConstellation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PostUniverseIdsConstellationToJSON(json: any): PostUniverseIdsConstellation {
    return PostUniverseIdsConstellationToJSONTyped(json, false);
}

export function PostUniverseIdsConstellationToJSONTyped(value?: PostUniverseIdsConstellation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

